import { render, staticRenderFns } from "./refunDetail.vue?vue&type=template&id=6864d774&scoped=true&"
import script from "./refunDetail.vue?vue&type=script&lang=js&"
export * from "./refunDetail.vue?vue&type=script&lang=js&"
import style0 from "./refunDetail.vue?vue&type=style&index=0&id=6864d774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864d774",
  null
  
)

export default component.exports